import React, { ComponentProps, useCallback, useEffect, useRef } from 'react'

import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight'
import { Grid, Link as MuiLink } from '@mui/material'

import { Icon } from '../Icon/Icon'
import { useMegaMenuContext } from './MegaMenuContext'
import { StyledGrid, StyledTab } from './styledTab'

export type MegaMenuTabProps = ComponentProps<typeof MuiLink> & {
  children?: React.ReactNode
  idx: number
  href?: string
}

export const MegaMenuTab: React.FC<MegaMenuTabProps> = ({ children, idx, ...props }) => {
  const { menuState, setMenuState } = useMegaMenuContext()
  const tabRef = useRef<HTMLDivElement>(null)

  const onTabActive = useCallback(() => {
    setMenuState((prev) => ({
      ...prev,
      megaMenuSelect: idx,
    }))
  }, [setMenuState, idx])

  useEffect(() => {
    if (tabRef && tabRef.current) {
      tabRef.current.addEventListener('mouseenter', onTabActive)
    }
  }, [setMenuState, onTabActive, idx, tabRef])

  return (
    <StyledGrid
      container
      justifyContent="space-between"
      alignItems="center"
      $active={menuState.megaMenuSelect === idx}
      ref={tabRef}
    >
      <Grid item>
        <StyledTab {...props} variant="body1" href="#">
          {children}
        </StyledTab>
      </Grid>
      <Grid item>
        <Icon icon={faChevronRight} sx={{ width: '10px' }} width={10} height={16} />
      </Grid>
    </StyledGrid>
  )
}
